module.exports = __webpack_public_path__ + "static/media/purpleTheme.a1288ae6.jpg";